import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';
import user from 'js/lib/user';

const courseraPlusEnrollmentsApi = API('/api/courseraPlusEnrollments.v1', { type: 'rest' });

// TODO (htran) switch from Q.Promise to Promise once all of enrollmentChoiceUtils is converted over
export const enrollProduct = (
  productId: string,
  courseIdToGrantMembership?: string
): Q.Promise<Record<string, string>> => {
  const uri = new URI();
  uri.addQueryParam('action', 'enrollProduct');
  uri.addQueryParam('userId', user.get().id);
  uri.addQueryParam('productId', productId);

  if (courseIdToGrantMembership) {
    uri.addQueryParam('courseIdToGrantMembership', courseIdToGrantMembership);
  }

  return Q(courseraPlusEnrollmentsApi.post(uri.toString()));
};

export const unenrollProduct = (productId: string): Promise<Record<string, string>> => {
  const uri = new URI();
  uri.addQueryParam('action', 'unenrollProduct');
  uri.addQueryParam('userId', user.get().id);
  uri.addQueryParam('productId', productId);

  return Promise.resolve(courseraPlusEnrollmentsApi.post(uri.toString()));
};
